// 63版本相关多语言

export default {
    bankTransfer: {
        b000001: '待處理',
        b000002: '處理成功',
        b000003: '處理失敗',
        b000004: '自動處理',
        b000005: '退款到帳',
        b000006: '已取消',
        b000007: '轉入',
        b000008: '轉出',
        b000009: '付款',
        b000010: '全部',
        b000011: '沒有更多了',
        b000012: '出入金記錄',
        b000013: '換匯',
        b000014: '劃轉',
        b000015: '銀行帳戶',
        b000016: '提交',
        b000017: '已綁定',
        b000018: '個',
        b000019: '暫無數據',
        b000020: '轉帳',
        b000021: '賬戶號碼說明',
        b000022: '銀行賬號可能不同於銀行卡上所展示的卡號， 請正確填寫銀行賬號，如需幫助，請聯繫客服。',
        b000023: '如何找到銀行賬號？',
        b000024: '1、銀行結單',
        b000025: '2、網銀APP、網頁',
        b000026: '3、銀行開戶資料',
        b000027: '4、銀行卡片',
        b000028: '示例',
    },
    moneyExchange: {
        m000001: [
            "注意事項：",
            "1、暫不提供超過500000港幣或等值貨幣的兌換。",
            "2、匯率僅做參考，實際匯率將按照處理時匯率為準。",
            "3、默認以換入貨幣計算換出貨幣，如需固定換出金額，請在備註中寫明。",
        ],
        m000002: '備註',
        m000003: '由金額',
        m000004: '換匯至金額',
        m000005: '參考匯率',
        m000006: '更新',
        m000007: '可轉出總計',
        m000008: "美元",
        m000009: "港幣",
        m000010: "人民幣",
        m000011: "換匯記錄",
        m000012: "參考匯率",
        m000013: "暫不取消",
        m000014: "是否確認取消？",
        m000015: "取消成功",
        m000016: "訂單編號",
        m000017: "取消",
        m000018: "資金換匯",
        m000019: ['待處理', '處理中', '處理成功', '處理失敗', '已取消', '服務異常'],
        m000020: ['待處理','處理成功','處理失敗','訂單取消'],
        m000021: "換匯幣種選擇衝突",
    },
    fundsTransfer: {
        f000001: '轉出帳戶',
        f000002: '不能為空',
        f000003: '轉入帳戶',
        f000004: '幣種',
        f000005: '金額',
        f000006: '資金劃轉',
        f000007: '驗證登錄密碼',
        f000008: '溫馨提示',
        f000009: '知道了',
        f000010: '資金劃轉訂單提交成功',
        f000011: '密碼不能為空',
        f000012: '資金劃轉記錄',
        f000013: '預計1個工作日生效',
        f000014: '確認',
    },
    transferInto:{
        lang:'請選擇匯款銀行',
        lang0:'港元、美元、人民幣',
        lang1:'填寫並上傳匯款憑證',
        lang2: {
            title: "存入幣種",
            colums: [
                {
                    text: "港幣",
                    value: "HKD"
                },
                {
                    text: "美元",
                    value: "USD"
                },
                {
                    text: "人民幣",
                    value: "CNH"
                }
            ]
        },
        lang3:'存入帳戶',
        lang4:'存入金額',
        lang5:'請輸入存入金額',
        lang6:'資金轉入訂單提交成功',
        lang7:'預計到帳時間1-3個工作日',
        lang8:'知道了',
        lang9:'請選擇存入幣種',
        lang10:'請選擇存入帳戶',
        accountName:["期貨帳戶","證券帳戶"],
    },
    transferIntoAbroad:{
        lang:'按照下列信息填寫匯款單',
        lang0:'手續費，同行免費',
        lang1:'到帳時間：預計1~3個工作日內',
        lang2:'帳戶名稱',
        lang3:'收款帳號',
        lang4:'(港幣)',
        lang5:'(美元)',
        lang6:'(人民幣)',
        lang7:'銀行名稱',
        lang8:'銀行地址',
        lang9:'復制',
        lang10:'我已匯款,上傳憑證',
        tips: [
            "備註：",
            "為保障客戶權益，匯款後請盡快上傳入金憑證以供核對；",
            "如銀行轉帳涉及手續費，我司有機會在入帳後客戶資金扣除；",
            "入金是根據銀行工作時間作匯款安排，如非工作時段有機會延遲及衍生利息",
        ],
        lang11:'復制成功',
        lang12:'FPS轉數快識別碼',
    },
    withdrawNew:{
        lang:'帳戶列表',
        lang0:'轉出幣種',
        lang1:'請選擇轉出幣種',
        lang2:'轉出銀行卡',
        lang3:'請選需要轉出的銀行卡',
        lang4:'轉出金額',
        lang5:'請輸入轉出金額',
        lang6:'全部餘額',
        tips:[
            '資金轉出說明',
            '1.匯率會在壹定期限內變動,實際到帳資金可能與預計到帳金額存在差別；',
            '2.請確保您選擇的銀行卡能夠接收您的轉出幣種,以免資金不能及時到帳。'
        ],
        lang7:'驗證登錄密碼',
        lang8:'資金轉出訂單提交成功',
        lang9:'預計到帳時間1~3個工作日',
        lang10:'您未綁定銀行卡',
        lang11:'資金需要指定轉出的銀行卡',
        lang12:'暫不處理',
        lang13:'去綁定',
        lang14:'註意：銀行卡必須能夠接收上述幣種'
    },
    agencyList:{
        lang:'消息通知',
        lang0:'驗證郵件已發送至您的郵箱',
        lang1:'打開郵件激活',
        lang2:'若未能找到郵件，請在垃圾郵件中查找 如鏈接失效，請點擊重新',
        lang3:'重新發送',
        lang4:[{name:'消息',value:1}, {name:'待辦',value:2}],
        lang5:'發送成功',
        lang6:'則',
        lang7:'活動推送',
        lang8:'查看詳情',
    },
    bankCardPage: {
        t00001: '請選擇您的銀行帳戶'
    },
    findPwd: {
        t00001: '如遇問題，請',
        t00002: '請輸入開戶的證件帳號',
        t00003: '請設置登錄密碼',
        t00004: '你的帳號為',
        t00005: '密碼至少8個字符',
        t00006: '密碼為數字和字母組合',
        t00007: '兩次輸入的新密碼需要一致'
    },
    accountAnalysis: {
        a00001: '賬戶分析',
        a00002: '暫無數據',
        a00003: '統計時間',
        a00004: '資產圖',
        a00005: '淨值圖',
        a00006: '資產',
        a00007: '累計淨值',
        a00008: '數據加載中',
    },
    helpCenterNew: {
        m00000: '幫助中心',
        m00001: '請輸入您遇到的問題',
        m00002: '搜索中...',
        m00003: '暫無搜索結果',
        m00004: '猜你想問',
        m00005: '問題分類',
        m00006: '其他',
        m00007: '',
        m00008: '',
        m00009: '',
    },
    privateFund: {
        title: '私募基金',
        bannerTitleLine1: '嚴選全球資管',
        bannerTitleLine2: '穿越周期配置',
        bannerSubtitle: '專業 · 穩健 · 長期價值',
        view: '查看',
        netValue: '資產管理規模（十億）',
        returnYtd: '收益（年計）',
        returnSinceInception: '收益（月計）',
        list: {
            view: '查看',
            assetsUnderManagement: '資產管理規模（{unit}）',
            assetsUnderManagementPlain: '資產管理規模',
            assetsUnderManagementBillion: '資產管理規模（十億）',
            assetsUnderManagementMillion: '資產管理規模（百萬）',
            returnYtd: '收益（年計）',
            returnSinceInception: '收益（月計）',
        },
        disclaimer: {
            title: '免責聲明及使用條款',
            paragraph1: '本文件所載之資料及文件乃由高盈證券有限公司（「高盈證券」）透過其移動應用程式提供及分發。',
            paragraph2: '本文件所載之資料及文件不應被視為對任何證券或投資產品之任何形式之推薦、要約、邀請、招攬、廣告、勸誘或任何種類之陳述。其並不構成在任何司法管轄區向公眾作出之要約或招攬。',
            paragraph3: '本文件所載之資料及文件僅供專業投資者（定義見香港法例第571章《證券及期貨條例》）使用，並嚴格限於香港境內使用。 其並非供任何其他司法管轄區之人士分發或使用，而在該等司法管轄區進行有關分發或使用將違反當地法律或規例。除非事先獲得高盈證券之書面同意，任何接收者不得以任何方式複製、分發或轉發本文件所載之資料及文件或其中任何部分予任何其他人士。',
            copyright: '© 2026 高盈證券有限公司。保留一切權利。',
            confirm: '關閉',
        },
        finishedText: '沒有更多了',
        listPlaceholder: '列表頁開發中',
        detailPlaceholder: '詳情頁開發中',
        tabOverview: '基金概覽',
        tabPerformance: '基金業績',
        performanceNavTrend: '每股資產淨值',
        performanceNavUnit: '（千美元）',
        performanceNavPeriod: '自成立以來(每月)',
        performanceChartNavLabel: '淨值',
        navMiniChartTooltipValue: '每股資產淨值：{value}',
        performanceChartNoData: '暫無數據',
        sectionOverview: '概況',
        sectionSubscription: '申購',
        sectionRedemption: '贖回',
        sectionFees: '費用',
        sectionStrategy: '投資策略',
        strategyPrefix: '主要投資策略: ',
        productName: '產品名稱',
        fundCompany: '基金公司',
        currency: '幣種',
        subscriptionDay: '申購日',
        subscriptionPrice: '申購價',
        minSubscription: '起購金額',
        additionalSubscription: '追加金額',
        shareLockUp: '份額鎖定',
        redemptionDay: '贖回日',
        minRedemption: '最小贖回',
        minHolding: '最小持有',
        subscriptionFee: '申購費',
        redemptionFee: '贖回費',
        managementFee: '管理費',
        performanceFeeRatio: '業績報酬計提比例',
        performanceFeeFrequency: '業績報酬計提頻率',
        learnMore: '進一步了解',
        subscribeApply: '認購申請',
        subscribe: {
            title: '認購申請',
            product: '認購產品',
            productNetValue: '產品淨值',
            securitiesAccount: '證券帳號',
            accountPlaceholder: '請輸入證券帳號',
            accountInvalid: '請輸入證券帳號',
            accountEmpty: '證券帳號不能為空',
            amount: '認購金額',
            amountPlaceholder: '請輸入金額',
            minAmountHint: '最小認購金額',
            estimatedShares: '預計認購份額',
            agreementPrefix: '本人已收悉、閱讀及理解本基金的',
            agreementTerms: '《基金條款清單》',
            agreementMemo: '《私募配售備忘錄》',
            agreementAppendix: '《基金附錄》',
            agreementDisclosure: '《基金交易前披露確認聲明》',
            agreementBetween: '、',
            agreementAnd: '及',
            agreementSuffix: '中的風險披露。我已明白本基金屬複雜產品，並已理解上述所有風險。',
            submit: '提交',
            amountInvalid: '認購金額須大於0',
            minAmountInvalid: '認購金額低於起購金額',
            stepAmountInvalid: '認購金額須為起購金額加追加金額的整數倍',
            fundIdEmpty: '產品信息缺失，請返回重試',
            tokenEmpty: '請登錄後操作，token 為空',
            submitSuccessMessage: '您的認購申請已提交，相關文件已寄至您的註冊郵箱，請查收。客服將在1-3個工作日與您聯繫，完成後續認購流程',
            confirm: '確定',
        },
        order: {
            title: '基金訂單',
            entry: '基金訂單',
            colName: '名稱',
            colAmount: '認購金額',
            colCurrency: '幣種',
            colStatus: '狀態',
            colTime: '認購時間',
            statusSubmitted: '已提交',
            statusAccepted: '已受理',
            statusRejected: '已拒絕',
            statusCancelled: '已取消',
        },
    }
}
